function modalAction() {
  // デフォルト
  const actionButton = document.querySelectorAll('[data-owd-modal="modalButton"]');
  const contentArea = document.querySelector(".owd-inner")
  if (!actionButton) {
    return;
  }

  actionButton.forEach(clickButton => {
    clickButton.addEventListener('click', (e) => {
      const clickElData = clickButton.dataset.modalType;
      ///同じdataset.modalTypeのowdModalを取得
      const targetModal = document.querySelector(`.owd-modal[data-modal-contents-type="${clickElData}"]`);
      const targetElData = targetModal.dataset.modalContentsType;
      if(clickElData === targetElData){
        targetModal.classList.add("is-show");
        document.body.style.overflow = 'hidden';

        const scrollToId = clickButton.dataset.scrollTo;
        if (scrollToId) {
          const scrollTarget = document.getElementById(scrollToId);
          console.log('scrollToId----'+ scrollToId);
          setTimeout(() => {
            scrollTarget.scrollIntoView({
              behavior: 'smooth'
            });
          }, 500);
        }

        // click押下した時に要素を走査するためここに記入
        const pageTopButton = document.querySelector(".owd-button-pagetop-wrap")
        pageTopButton ? pageTopButton.style.display = "none" : null

        contentArea.style.zIndex = "4"
      }

      const closeButton = targetModal.querySelectorAll('[data-owd-modal="closeButton"]');
      function _close(){
        targetModal.classList.remove("is-show");
        document.body.style.overflow = '';
        const pageTopButton = document.querySelector(".owd-button-pagetop-wrap")
        pageTopButton ? pageTopButton.style.display = "block" : null

      }
      if (closeButton) {
        closeButton.forEach(b => {
          b.addEventListener('click', () => {
            _close();
            contentArea.style.zIndex = "1"
          });
        });
      };
      // モーダルの背景部分をクリックしたら閉じる処理
      targetModal.addEventListener('click', (e) => {
        if (e.target === targetModal) {
          _close();
        }
      });
    });
  });
}

export {modalAction}
